<template>
  <div class="p-2">
    <div class="d-flex flex-wrap">
      <div class="d-flex flex-column mb-2 w-100 w-sm-50">
        <span class="text-secondary property-label">
          Key
        </span>
        <span class="text-main">
          {{ file.key }}
        </span>
      </div>
      <div class="d-flex flex-column w-100 w-sm-50 mb-2">
        <span class="text-secondary property-label">
          Bucket name
        </span>
        <span class="text-main">
          {{ file.bucketName }}
        </span>
      </div>
      <div class=" d-flex flex-column w-100 w-sm-50 mb-2">
        <span class="text-secondary property-label">
          Type
        </span>
        <span class="text-main">
          {{ file.contentType }}
        </span>
      </div>
      <div class="d-flex flex-column w-100 w-sm-50 mb-2">
        <span class="text-secondary property-label">
          Size
        </span>
        <span class="text-main">
          {{ formatBytes(file.contentLength) }}
        </span>
      </div>
      <div class=" d-flex flex-column w-100 w-sm-50 mb-2">
        <span class="text-secondary property-label">
          Last Modified
        </span>
        <span class="text-main">
          {{ formatOffsetDateTime(file.lastModified) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>

import helpers from '@/mixins/helpers'

export default {
  name: 'FileProperties',
  components: {
  },
  mixins: [helpers],
  props: {
    file: {
      type: Object,
      default: null,
      required: true,
    },
    lastFileFetch: {
      type: String,
      default: null,
    },
    accountId: {
      type: [Number, String],
      required: true,
    },
  },

}
</script>

<style>
  span.property-label{
    margin-bottom:8px;
  }
</style>
